module.exports = __webpack_public_path__ + "img/404.25adaf06.svg";